/* STL·SVG 를 다른 화면으로 넘길 때 쓰는 IndexedDB 보관함 (2026-10-16 김현비).
   - 3D프린팅 주문: db "cookistory_order" v1 / store "stl" / key "pending_order" / { blob, fileName }
     (쿠키커터 만들기 goOrderWithCurrentStl 과 같은 형식 — 형식을 바꾸면 주문 쪽도 같이 바꿔야 한다)
   - 갤러리 올리기: db "cookistory_gallery_handoff" v1 / store "handoff" / key "pending"
     / { stlBlob, svgText, baseName } — 주문 보관함과 따로 둬서 버전 올림 충돌이 없다. */

function openStore(dbName, storeName) {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(dbName, 1);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(storeName)) db.createObjectStore(storeName);
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror = () => reject(req.error || new Error("indexedDB open failed"));
  });
}

function put(dbName, storeName, key, value) {
  return openStore(dbName, storeName).then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).put(value, key);
        tx.oncomplete = () => { db.close(); resolve(); };
        tx.onerror = () => { db.close(); reject(tx.error); };
      })
  );
}

/** 3D프린팅 주문 화면으로 STL 넘기기 */
export function saveOrderStl(blob, fileName) {
  return put("cookistory_order", "stl", "pending_order", { blob, fileName });
}

/** 꺼내고 바로 지우기 (없으면 null) — 주문·갤러리 보관함 공용 */
function take(dbName, storeName, key) {
  return openStore(dbName, storeName).then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);
        let value = null;
        const getReq = store.get(key);
        getReq.onsuccess = () => {
          value = getReq.result || null;
          store.delete(key);
        };
        tx.oncomplete = () => { db.close(); resolve(value); };
        tx.onerror = () => { db.close(); reject(tx.error); };
      })
  );
}

/** 3D프린팅 주문 화면: 넘겨받은 STL 꺼내기 ({ blob, fileName } 또는 null) */
export function takeOrderStl() {
  return take("cookistory_order", "stl", "pending_order");
}

/** 쿠키커터 만들기 → 갤러리 올리기 */
export function saveGalleryHandoff({ stlBlob, svgText, baseName }) {
  return put("cookistory_gallery_handoff", "handoff", "pending", { stlBlob, svgText, baseName });
}

/** 갤러리 올리기 화면: 넘겨받은 값을 꺼내고 바로 지운다 (없으면 null) */
export function takeGalleryHandoff() {
  return take("cookistory_gallery_handoff", "handoff", "pending");
}
